module.exports = __webpack_public_path__ + "img/img_sample2.ba4e9e28.jpg";